<div mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
  <span class="h2" style="font-weight: 600;">{{ 'WALLET' | translate }}</span>
  <!--<button
    mat-raised-button
    color="accent"
    style="height: 36px;"
    (click)="exportWalletCsv(walletTransactions)"
    [disabled]="!walletTransactions || walletTransactions.length === 0"
  >
    {{ 'EXPORT_CSV' | translate }}
  </button>-->
  <span fxFlex></span>
  <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">
    {{ 'EXPORT' | translate }}
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="export('csv')">{{ 'EXPORT_CSV' | translate }}</button>
    <button mat-menu-item (click)="export('xls')">{{ 'EXPORT_XLS' | translate }}</button>
  </mat-menu>
</div>

<mat-dialog-content id="custom-table">
  <mat-table #table [dataSource]="walletTransactions" [@animateStagger]="{ value: '50' }">
    <!-- date -->
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" fxFlex="100px">
        {{ 'DATA' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let transaction" fxLayoutAlign="center center" fxFlex="100px">
        <span class="text-center">{{ transaction.date | date: 'dd/MM/yyyy hh:mm:ss' }}</span>
      </mat-cell>
    </ng-container>

    <!-- comment -->
    <ng-container matColumnDef="comment">
      <mat-header-cell *matHeaderCellDef> {{ 'REASON' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let transaction" class="p-12">
        <span class="text-left">{{ transaction.comment }}</span>
      </mat-cell>
    </ng-container>

    <!-- invoiceId -->
    <ng-container matColumnDef="invoiceId">
      <mat-header-cell *matHeaderCellDef> {{ 'INVOICE_ID' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let transaction" class="p-12">
        <span class="text-left">{{ transaction.invoiceId }}</span>
      </mat-cell>
    </ng-container>

    <!-- type -->
    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef> {{ 'TYPE' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let transaction" class="p-12">
        <span class="text-left">{{ transaction.type }}</span>
      </mat-cell>
    </ng-container>

    <!-- amountDeb -->
    <ng-container matColumnDef="amountDeb">
      <mat-header-cell *matHeaderCellDef fxLayoutAlign="end center" fxFlex="110px">
        <span class="text-right">{{ 'DEBT_AMOUNT' | translate }}</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let transaction" fxLayoutAlign="end center" fxFlex="110px">
        <ng-container
          *ngIf="
            transaction.sender.toUpperCase() ===
              buyerService.userFund(buyerService.fundId).walletId.toUpperCase();
            else receiver
          "
        >
          <span class="red-800-fg">{{ transaction.amount | currency: 'EUR' }}</span>
        </ng-container>
        <ng-template #receiver> - </ng-template>
      </mat-cell>
    </ng-container>

    <!-- amountCred -->
    <ng-container matColumnDef="amountCred">
      <mat-header-cell *matHeaderCellDef fxLayoutAlign="end center" fxFlex="134px">
        <span class="text-right">{{ 'CREDIT_AMOUNT' | translate }}</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let transaction" fxLayoutAlign="end center" fxFlex="134px">
        <ng-container
          *ngIf="
            transaction.reciver.toUpperCase() ===
              buyerService.userFund(buyerService.fundId).walletId.toUpperCase();
            else sender
          "
        >
          <span class="blue-800-fg">{{ transaction.amount | currency: 'EUR' }}</span>
        </ng-container>
        <ng-template #sender> - </ng-template>
      </mat-cell>
    </ng-container>

    <mat-header-row
      class="fixed-header"
      *matHeaderRowDef="displayedColumns; sticky: true"
    ></mat-header-row>
    <mat-row
      *matRowDef="let transaction; columns: displayedColumns"
      class="custom-row"
      style="cursor: default;"
    >
    </mat-row>
  </mat-table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="accent" mat-dialog-close>
    <span>{{ 'CLOSE' | translate }}</span>
  </button>
</mat-dialog-actions>
